// extracted by mini-css-extract-plugin
export default {"searchForm":"WeatherSearch_searchForm__ytZlv"};